import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';
import { LoadingSpaceAxleLoadsComponent } from 'src/app/main-panel/add-loading-space/components/loading-space-axle-loads/loading-space-axle-loads.component';
import { LoadingSpaceType } from '../types';

export const NUMERIC_VALIDATORS = {
  float: isFloat('(^(?!-)[0-9]+[.,]?[0-9]*$)|^$'),
  integer: isInteger('^(?!-)[0-9]+$|^$'),
  floatNeg: isFloat('(^-?[0-9]+[.,]?[0-9]*$)|^$'),
};

function isInteger(reg: string): ValidatorFn {
  return (control: AbstractControl): Record<string, any> | null => {
    const regExp = new RegExp(reg);
    const forbidden = control.value !== null && !regExp.test(control.value);
    return forbidden ? { notInteger: { value: control.value } } : null;
  };
}

function isFloat(reg: string): ValidatorFn {
  return (control: AbstractControl): Record<string, any> | null => {
    const regExp = new RegExp(reg);
    const forbidden = control.value !== null && !regExp.test(control.value);
    return forbidden ? { notFloat: { value: control.value } } : null;
  };
}

export function validateZero(control: AbstractControl) {
  if (control.value && control.value <= 0) {
    return { required: true };
  }
  return null;
}

export function validateCheckboxRequired(control: AbstractControl) {
  if (!control.value) {
    return { required: true };
  }
  return null;
}

export function validateMaxLoadingSpace(maxNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value > maxNumber) {
      return { maxLoadingSpace: maxNumber };
    }
    return null;
  };
}

export function validateIsStringInArray(arrayData: string[], disable = false): ValidatorFn {
  return (control: AbstractControl) => {
    if (disable) {
      return null;
    }
    if (control.value && arrayData && arrayData.some(name => name === control.value)) {
      return { notUnique: true };
    }
    return null;
  };
}

export function validateMax(maxNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value > maxNumber) {
      return { maxValue: maxNumber };
    }
    return null;
  };
}

export function validateMinVarioFloorThickness(minNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value.length < minNumber) {
      return { minVarioFloorThickness: minNumber };
    }
    return null;
  };
}

export function validateMaxVarioFloorThickness(maxNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value > maxNumber) {
      return { maxVarioFloorThickness: maxNumber };
    }
    return null;
  };
}


export function validateMaxVarioFloorCapacity(maxNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value > maxNumber) {
      return { maxVarioFloorCapacity: maxNumber };
    }
    return null;
  };
}

export function validateMin(minNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value.length < minNumber) {
      return { minValue: minNumber };
    }
    return null;
  };
}

export function validateEqual(equalNumber: number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value && control.value.length !== equalNumber) {
      return { equalValue: true };
    }
    return null;
  };
}

export function validateLoadingSpace(
  loadingSpace: LoadingSpaceType,
  axleComponent?: LoadingSpaceAxleLoadsComponent,
): ValidatorFn {
  return (control: AbstractControl): Record<string, boolean> => {
    const { controls } = control.parent;
    if (
      loadingSpace &&
      (parseFloat(controls['firstPart'].value.length) !== loadingSpace.length ||
        parseFloat(controls['firstPart'].value.height) !== loadingSpace.height ||
        parseFloat(controls['firstPart'].value.limit) !== loadingSpace.limit ||
        parseFloat(controls['firstPart'].value.width) !== loadingSpace.width ||
        controls['set'].value !== loadingSpace.set)
    ) {
      return { changeName: true };
    }
    if (
      loadingSpace &&
      loadingSpace.axis &&
      loadingSpace.axis.length > 0 &&
      axleComponent &&
      (parseFloat(axleComponent.form.controls['firstPartAxle'].value.distanceFromSpaceFront) !==
        _.round(loadingSpace.axis[0].distanceFromSpaceFront) ||
        parseFloat(axleComponent.form.controls['firstPartAxle'].value.emptySpaceLoad) !==
          loadingSpace.axis[0].emptySpaceLoad ||
        parseFloat(axleComponent.form.controls['firstPartAxle'].value.maxLoad) !==
          loadingSpace.axis[0].maxLoad ||
        parseFloat(axleComponent.form.controls['firstPartAxle'].value.distanceFromSpaceFront1) !==
          _.round(loadingSpace.axis[1].distanceFromSpaceFront) ||
        parseFloat(axleComponent.form.controls['firstPartAxle'].value.emptySpaceLoad1) !==
          loadingSpace.axis[1].emptySpaceLoad ||
        parseFloat(axleComponent.form.controls['firstPartAxle'].value.maxLoad1) !==
          loadingSpace.axis[1].maxLoad)
    ) {
      return { changeName: true };
    }

    if (
      loadingSpace &&
      loadingSpace.axis &&
      loadingSpace.axis.length > 0 &&
      axleComponent &&
      controls['set'].value === true &&
      (parseFloat(axleComponent.form.controls['secondPartAxle'].value.setDistanceFromSpaceFront) !==
        _.round(loadingSpace.axis[2].distanceFromSpaceFront) ||
        parseFloat(axleComponent.form.controls['secondPartAxle'].value.setEmptySpaceLoad) !==
          loadingSpace.axis[2].emptySpaceLoad ||
        parseFloat(axleComponent.form.controls['secondPartAxle'].value.setMaxLoad) !==
          loadingSpace.axis[2].maxLoad ||
        parseFloat(
          axleComponent.form.controls['secondPartAxle'].value.setDistanceFromSpaceFront1,
        ) !== _.round(loadingSpace.axis[3].distanceFromSpaceFront) ||
        parseFloat(axleComponent.form.controls['secondPartAxle'].value.setEmptySpaceLoad1) !==
          loadingSpace.axis[3].emptySpaceLoad ||
        parseFloat(axleComponent.form.controls['secondPartAxle'].value.setMaxLoad1) !==
          loadingSpace.axis[3].maxLoad)
    ) {
      return { changeName: true };
    }
    return null;
  };
}
